/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@material-ui/core';
import React from 'react';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import { PaperComponent } from '../../../../../SharedModules/utilities/utilities';

const ErrorPopup = ({ modalTitle = 'Alert', errorPopupMessage, onClose }) => {
  return (
    <Dialog
      open={Boolean(errorPopupMessage)}
      className="multiGroupDialog custom-dialog-box dialog-420"
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
    >
      <div style={{ cursor: 'move' }} id="draggable-dialog-title">
        <DialogContent>
          <div className="custom-panel">
            <div className="panel-header">
              <span className="float-left"> {modalTitle} </span>
              <span className="float-right" role="button" onClick={onClose}>
                <i className="fa fa-times-circle" aria-hidden="true" />
              </span>

              <div className="clearfix" />
            </div>
            <div className="text-center modal-alignment">
              <DialogContentText style={{ color: 'black' }}>
                {errorPopupMessage}
              </DialogContentText>
            </div>
          </div>
        </DialogContent>

        <DialogActions>
          <div className="btn-wrapper my-2">
            <Button
              onClick={onClose}
              color="primary"
              className="btn btn-success btn-search mr-2"
              autoFocus
            >
              <SVGComponent iconName="Icon_awesome-check-circle" />
              OK
            </Button>
          </div>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default ErrorPopup;
